import { render } from "./matchImageAndQuestions.vue?vue&type=template&id=4717805c&scoped=true&ts=true"
import script from "./matchImageAndQuestions.vue?vue&type=script&lang=ts"
export * from "./matchImageAndQuestions.vue?vue&type=script&lang=ts"

import "./matchImageAndQuestions.vue?vue&type=style&index=0&id=4717805c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4717805c"]])

export default __exports__